module.exports = __webpack_public_path__ + "img/hot_jgg.5d2dc463.svg";